import * as React from "react";
import styled, { css } from "styled-components";
import { select } from "@hubper/theme";

const HEIGHT = 40;
const WIDTH = 20;
const ICON_SIZE = 20;

const Base = styled.div<{ isOpen: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${HEIGHT}px;
  width: ${WIDTH}px;
  position: relative;
  cursor: pointer;
  box-sizing: border-box;

  &:hover {
    span {
      background-color: ${select.color(["grey", 9])};
    }
  }
`;

const Inner = styled.div<{ isOpen: boolean }>`
  position: relative;
  width: 100%;
  height: ${ICON_SIZE}px;
  transition: 0.3s ease-in-out;

  & > span {
    display: block;
    position: absolute;
    height: 2px;
    width: 100%;
    background-color: ${select.color(["grey", 6])};
    border-radius: 9px;
    opacity: 1;
    left: 0;
    transform: rotate(0deg);
    transform-origin: 50% 50%;
    will-change: transform;
    transition: 0.2s ease-in-out;

    &:nth-child(1) {
      top: 5px;

      ${({ isOpen }) =>
        isOpen &&
        css`
          top: ${ICON_SIZE / 2 - 1}px;
          transform: rotate(-45deg);
        `}
    }
    &:nth-child(2) {
      top: calc(100% - 7px);

      ${({ isOpen }) =>
        isOpen &&
        css`
          top: ${ICON_SIZE / 2 - 1}px;
          transform: rotate(45deg);
        `}
    }
  }
`;

type Props = {
  style?: React.CSSProperties;
  className?: string;
  isOpen: boolean;
  onClick: () => void;
};

function HamburgerMenu({ style, className, isOpen, onClick }: Props, ref: any) {
  return (
    <Base
      ref={ref}
      style={style}
      className={className}
      isOpen={isOpen}
      onClick={onClick}
    >
      <Inner isOpen={isOpen}>
        <span />
        <span />
      </Inner>
    </Base>
  );
}

export default React.forwardRef(HamburgerMenu);
